import stock from './stock'

export const queries = {
  stock,
}
export default queries
